/** Estados de un proceso legal tal como los envía el backend en `statusLegalCase`. */
export const LegalCaseStatusEnum = {
    /** Marca el proceso en mora: chip de alerta y bloque de pensiones e intereses pendientes. */
    IN_ARREARS: 'EN MORA',
} as const;
